import React, { useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { List, ListItem, ListItemIcon, ListItemText, Collapse } from '@mui/material';
import c from 'classnames';
import PropTypes from 'prop-types';

import { ReactComponent as SettingsIcon } from '../../../../assetsNew/icons/menu/settings.svg';
import { ReactComponent as ArrowUpIcon } from '../../../../assetsNew/icons/menu/keyboard-arrow-up.svg';
import { ReactComponent as ArrowDownIcon } from '../../../../assetsNew/icons/menu/keyboard-arrow-down.svg.svg';
import { matchRoute } from '../../../../utils/matchRoute';
import { settingsItems, subMenuObjects } from '../../../../utils/menu';

import './_settingsMenu.scss';

const SettingsMenu = ({ isAdmin }) => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [expand, setExpand] = useState(subMenuObjects(isAdmin));
  const stripeUrl = useSelector(s => s.stripeBilling?.data?.url || '');

  const handleClick = key => {
    setExpand({
      ...expand,
      [key]: !expand[key]
    });
  };

  const renderMenuItems = items => (
    items.map(element => {
      let active = element.path ? matchRoute(pathname, element.path) : false;

      return element.path ? (
        <Link to={element.path} key={element.id} className={c('menu-item', { 'active': active })}>
          {active && <div className="active-line" />}
          <ListItemIcon>{element.icon}</ListItemIcon>
          <ListItemText className="text" primary={element.title} />
        </Link>
      ) : (
          element.title !== 'Payments' ? (
            <Fragment key={element.id}>
              <ListItem button className={c('menu-item')} onClick={() => handleClick(element.id)}>
                <ListItemIcon>
                  <>
                    {element.icon}
                  </>
                </ListItemIcon>
                <ListItemText className="text" primary={element.title} />
                {
                  element.more
                    ? expand[element.id] ? <ArrowUpIcon className="expandIcon" /> : <ArrowDownIcon className="expandIcon" />
                    : null
                }
              </ListItem>
              {
                element.more && expand[element.id] && (
                  <Collapse in={Boolean(expand)} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {
                        element.more.map(el => {
                          active = matchRoute(pathname, el.path);

                          return (
                            <Link to={el.path} className={c('menu-item sub', { 'active': active })} key={el.id} >
                              {active && <div className="active-line" />}
                              <ListItemIcon>{el.icon}</ListItemIcon>
                              <ListItemText className="text" primary={el.title} />
                            </Link>
                          );
                        })
                      }
                    </List>
                  </Collapse>
                )
              }
          </Fragment>
          ) : (
            <a href={stripeUrl} className={c('menu-item', { 'active': active })} key={element.id}>
              <ListItemIcon>{element.icon}</ListItemIcon>
              <ListItemText className="text" primary={element.title} />
            </a>
          )
        );
    })
  );

  return (
    <div className="settingsMenu">
      <ListItem button className={c('menu-item settingsMenu-expand')} onClick={() => setOpen(prev => !prev)}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText className="text" primary="Settings" />
        {open && <ArrowDownIcon className="expandIcon" />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit className="settingsMenu-collapse">
        <List component="div" className="settingsMenu-list">
          {renderMenuItems(settingsItems(isAdmin))}
        </List>
      </Collapse>
    </div>
  );
};

SettingsMenu.propTypes = {
  isAdmin: PropTypes.bool
};

export default SettingsMenu;